<nav class="navbar navbar-expand-lg navbar-dark" style="background-color: #232528">
    <!--<nav class="navbar navbar-expand-lg navbar-dark bg-dark">-->
    <a class="navbar-brand" href="#"><img src="assets/hnl-header.png" height="60em" alt="HereNowLIVE!"></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
    <div class="navbar-nav">
        <a [className]="activePath('/welcome') ? 'nav-link active' : 'nav-link'" href="welcome">Briefing</a>
        <a [className]="activePath('/schedule') ? 'nav-link active' : 'nav-link'" href="schedule">Itinerary</a>
        <a [className]="activePath('/info') ? 'nav-link active' : 'nav-link'" href="info">Recon</a>
        <a [className]="activePath('/quest') ? 'nav-link active' : 'nav-link'" href="loading">Missions <span class="sr-only">(current)</span></a>
        <a [className]="activePath('/leaderboard') ? 'nav-link active' : 'nav-link'" href="leaderboard">Leaderboard</a>
    </div>
    </div>
</nav>
